const Card = (props) => {
    return (
        <div className="card">
            <div className="dot"></div>
            <div className="main-card">
                <img src={props.image} alt="porto-img"/>
                <h2>{props.title}</h2>
                <p>{props.desc}</p>
                <a href={props.link} target="_blank" rel="noreferrer">{props.link}</a>
            </div>
        </div>
    )
}

export default Card;